import React from 'react';

const CaratRight = props => (
  <svg viewBox="0 0 28 28" {...props}>
    <path d="M6.547.595a1.73 1.73 0 00.199 2.366L17.551 14 6.75 25.035a1.725 1.725 0 00-.2 2.369 1.679 1.679 0 002.366.2l12.32-12.319a1.68 1.68 0 000-2.566L8.916.399a1.683 1.683 0 00-2.369.196z" />
  </svg>
);

export default CaratRight;
